// LIBRARIES
import styled from "styled-components";

// MISC
import { COLORS } from "../../constants/variables";
import cursorIcon from "assets/img/Cursor.png";

export const AlertCard = styled.a<{ $biggerCursor: boolean }>`
  width: 100%;
  min-width: 0;
  min-height: 112px;
  display: grid;
  grid-template-columns: 80px minmax(0, 1fr);
  gap: 16px;
  align-items: center;
  text-decoration: none;
  color: inherit;
  border-radius: 8px;
  cursor: ${({ $biggerCursor }) => $biggerCursor ? `url(${cursorIcon}), auto` : "pointer"};
  &:focus-visible { outline: 2px solid ${COLORS.Crimson}; outline-offset: 2px; }
  @media (max-width: 767px) {
    grid-template-columns: 64px minmax(0, 1fr);
    gap: 12px;
  }
`;

export const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  > img { display: block; width: 100%; height: 100%; }
  @media (max-width: 767px) { width: 64px; height: 64px; }
`;

export const Icon = styled.img``;

export const InfoContainer = styled.div`
  min-width: 0;
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const BodyWrapper = styled.div`
  min-width: 0;
  width: 100%;
  overflow-wrap: anywhere;
`;

export const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  > img { flex-shrink: 0; }
`;
